const generateGroupAssignmentValues = (referenceMap) => {
    let relatesToArray = [
        {
            "type": {
                "coding": [
                    {
                        "code": "part-of",
                        "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
                        "display": "Part Of"
                    }
                ]
            },
            "targetReference": {
                "reference": "Composition/" + referenceMap.compositionId,
                "type": "Composition",
                "display": referenceMap.compositionTitle
            }
        }
    ];
    if (referenceMap?.interventionDescriptionReference && referenceMap.comparatorDescriptionReference) {
        return {
            "definition": {
                "concept": {
                    "coding": [
                        {
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "code": "defined-in-handling-and-category",
                            "display": "Defined in handling and category elements"
                        }
                    ]
                }
            },
            "handling": "dichotomous",
            "category": [
                {
                    "name": referenceMap.interventionDescriptionReference.display || "intervention",
                    "valueReference": referenceMap.interventionDescriptionReference
                },
                {
                    "name": referenceMap.comparatorDescriptionReference.display || "comparator",
                    "valueReference": referenceMap.comparatorDescriptionReference
                }
            ],
            "relatesTo": relatesToArray
        };
    } else {
        return {
            "definition": {
                "concept": {
                    "coding": [
                        {
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "code": "defined-in-handling-and-category",
                            "display": "Defined in handling and category elements"
                        }
                    ]
                }
            },
            "handling": "dichotomous",
            "category": [
                {
                    "name": "intervention",
                    "valueCodeableConcept": { "text": "the intervention" }
                },
                {
                    "name": "comparator",
                    "valueCodeableConcept": { "text": "the comparator" }
                }
            ],
            "relatesTo": relatesToArray
        };
    }
};

export default generateGroupAssignmentValues;